import React, { useEffect } from "react";

const Z = () => {
  // useEffect(() => {
  //   const path = document.querySelector(".z-path"); // Select the path element of the SVG
  //   const pathLength = path.getTotalLength(); // Get the total length of the path

  //   // Set initial styles for the path
  //   path.style.strokeDasharray = pathLength; // Set the stroke dash array to the path length
  //   path.style.strokeDashoffset = pathLength; // Hide the stroke initially
  //   path.style.fill = "#242424"; // No fill initially
  //   path.style.stroke = "#242424"; // Set stroke to black
  //   path.style.transition = "none"; // Remove any previous transitions

  //   // Trigger the drawing animation (stroke dash offset)
  //   setTimeout(() => {
  //     path.style.transition = "stroke-dashoffset 3s ease"; // Animate the stroke drawing over 3 seconds
  //     path.style.strokeDashoffset = "0"; // Reveal the stroke (drawing effect)

  //     // After the drawing completes, start the fill animation
  //     setTimeout(() => {
  //       path.style.transition = "fill 2s ease"; // Animate fill color change from transparent to black in 2 seconds
  //       path.style.fill = "#242424"; // Slowly fill with black over 2 seconds
  //     }, 3000); // Start the fill animation 3 seconds after the stroke drawing begins
  //   }, 100); // Start the animation after 100ms
  // }, []);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
               // width: "100%",
        height: "80vh",
      }}
    >
      <svg
        id="Layer_1"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1080 1080"
        width="110%" // Adjusts size to fill the container
        height="110%" // Adjusts size to fill the container
      >
        <path
          className="z-path"
          d="M963.46,655.73h-327.8v-5.63l262.74-414.13h-210.82c-10.43.42-19.19,4.17-26.27,11.26-7.1,7.1-10.63,15.85-10.63,26.27v11.26h-6.26v-78.82c6.26,2.5,17.3,5,33.16,7.51,15.84,2.5,30.23,3.75,43.16,3.75h173.91c20.43,0,36.07-1.14,46.92-3.44,10.84-2.29,17.3-3.85,19.39-4.69v5.63l-267.74,422.26h198.93c22.1,0,40.24-7.09,54.42-21.27,14.17-14.17,24.6-32.94,31.28-56.3h6.25l-20.64,96.34Z"
          fill="none" // No fill initially
          stroke="black" // Stroke with black color
          strokeWidth="5" // Adjust stroke width if needed
        />
      </svg>
    </div>
  );
};

export default Z;
